// React
import React, { useCallback, useMemo } from 'react'
import { useNavigate, useLocation } from 'react-router-dom'
import classNames from 'classnames'
// External libs
import { get } from 'lodash'
// Material UI
import { ListItem, ListItemIcon, ListItemText } from '@material-ui/core'
// Styles
import useStyles from './SideMenuItem.styles'
import appStore from '../../../../redux/stores/app.store'
import EventActions from '../../../../redux/actions/event-actions/event.actions'

const SideMenuItem = ({ item }) => {
  const componentClasses = useStyles()

  const path = get(item, 'path', null)
  const action = get(item, 'action', null)
  const navigate = useNavigate()
  let location = useLocation()
  const pathname = get(location, 'pathname', null)
  const isSelected = useMemo(() => {
    return pathname.indexOf(path) > -1
  }, [pathname, path])

  const handleClick = useCallback(() => {
    if (!!path && path.trim() !== '') {
      const partnerId = appStore.getPartnerId()
      EventActions.onSibeBarMenuSelection(partnerId, path)
      navigate(path)
      return
    }

    if (!!action) {
      action()
      return
    }
  }, [navigate, path, action])

  const listItemRootClasses = useMemo(() => {
    if (!isSelected) {
      return componentClasses.listItemRoot
    }

    return classNames(
      componentClasses.listItemRoot,
      componentClasses.selectedListItemRoot,
    )
  }, [
    componentClasses.listItemRoot,
    componentClasses.selectedListItemRoot,
    isSelected,
  ])

  const listItemTextPrimaryClasses = useMemo(() => {
    if (!isSelected) {
      return componentClasses.listItemTextPrimary
    }

    return classNames(
      componentClasses.listItemTextPrimary,
      componentClasses.selectedListItemTextPrimary,
    )
  }, [
    componentClasses.listItemTextPrimary,
    componentClasses.selectedListItemTextPrimary,
    isSelected,
  ])

  return (
    <ListItem
      button
      classes={{ root: listItemRootClasses }}
      onClick={handleClick}
    >
      <ListItemIcon classes={{ root: componentClasses.listItemIconRoot }}>
        {React.cloneElement(item.icon, { selected: isSelected })}
      </ListItemIcon>
      <ListItemText
        primary={item.label}
        classes={{
          root: componentClasses.listItemTextRoot,
          primary: listItemTextPrimaryClasses,
        }}
      />
    </ListItem>
  )
}

SideMenuItem.defaultProps = {
  item: {},
}

export default SideMenuItem
